import { useTranslation } from 'react-i18next'
import classNames from 'classnames'

import {
  ICON_COLOR,
  ICON_HEIGHT_16,
  IconNG,
  IconWithTooltip,
} from '../../../../Icon'
import { Status, STATUS_SIZE_16 } from '../../../../Status'
import Text from '../../../../Text'

import * as styles from './ApplicantProfileWidgetStageScreeningRow.module.css'

import CheckmarkIcon from '../../../../../icons/checkmark.svg'
import InformationIcon from '../../../../../icons/info.svg'

function ApplicantProfileWidgetStageScreeningRow({
  hint,
  isDone,
  isLast,
  isLineDone,
  isNeedsYou,
  label,
  statusText,
  statusTextColor,
}) {
  const { t } = useTranslation()

  return (
    <div className={styles.ApplicantProfileWidgetStageScreeningRow}>
      <div className={styles.timeline}>
        <div className={isDone ? styles.circleDone : styles.circle}>
          {isDone ? (
            <IconNG
              Icon={CheckmarkIcon}
              color={ICON_COLOR.CurrentColor}
              size={ICON_HEIGHT_16}
            />
          ) : null}
        </div>
        {isLast ? null : (
          <div className={isLineDone ? styles.lineDone : styles.line} />
        )}
      </div>

      <div
        className={classNames(styles.content, {
          [styles.contentLast]: isLast,
          [styles.contentNeedsYou]: isNeedsYou,
        })}
      >
        <div className={styles.labelRow}>
          <Text className={styles.label}>{label}</Text>
          {statusText ? (
            <Status
              height={STATUS_SIZE_16}
              text={statusText}
              textColor={statusTextColor}
            />
          ) : null}
          {hint ? (
            <IconWithTooltip
              Icon={InformationIcon}
              className={styles.hintIcon}
              size={ICON_HEIGHT_16}
              svgSize={ICON_HEIGHT_16}
              tooltip={hint}
            />
          ) : null}
        </div>

        {isNeedsYou ? (
          <span className={styles.needsYou}>
            <span className={styles.needsYouDot} />
            {t('RentalPortal.ApplicantAttentionNeedsYouKey')}
          </span>
        ) : null}
      </div>
    </div>
  )
}

export default ApplicantProfileWidgetStageScreeningRow
